export default __webpack_public_path__ + "static/media/Blood.58e349aa.jpg";